// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2715":"b8a11a98cbb6bfb5","3942":"45886b59d7485966","4213":"3db1989b1a18ebe4","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};